import React from 'react'
import { Typography } from '@jota-ds/lib-react'

export default function Three() {
    return (
        <section className="three d-flex">
            <div className="max-width d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-5">
                        <img className="img-fluid img-left" alt="" src="/assets/ilustra.png" />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 d-flex align-items-center">
                        <div className="container-fluid">
                            <div className="mt-5 mt-md-0 font-14">
                                <Typography component="paragraph" size="small">NEM CACHOEIRA NEM CHOCOLATE, NEM OOMPA LOOMPA</Typography>
                            </div>
                            <div className="paragraph title">
                                <Typography component="heading" size="large">
                                    Os bilhetes dão <br/>
                                    acesso a algo <br />
                                    muito mais doce: <br />
                                    descontos em todos <br />
                                    os nossos atuais <br />
                                    e futuros cursos
                                </Typography>
                            </div>

                            <div className="row">
                                <div className="col-md-5 pb-5">
                                    <div className="d-flex">
                                        <img className="img-fluid" alt="" src="/assets/selo50.svg" />
                                        <div className="ms-3 d-flex align-items-center">
                                            <Typography component="heading" size="x-small">
                                                de desconto para <br />
                                                pessoas ex-alunas.
                                            </Typography>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 pb-5">
                                    <div className="d-flex">
                                        <div>
                                            <img className="img-fluid" alt="" src="/assets/selo25.svg" />
                                        </div>
                                        <div className="ms-3 d-flex align-items-center">
                                            <Typography component="heading" size="x-small">
                                                de desconto para <br />
                                                quem encontrar <br />
                                                um dos bilhetes <br />
                                                dourados por aí!
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
